<template>
  <lancamentos-lista-base tipo="receber" titulo="Financeiro - Contas a Receber" />
</template>

<script>
import LancamentosListaBase from '@/pages/financeiro/LancamentosListaBase';

export default {
  name: 'ContasReceberLista',
  components: {
    LancamentosListaBase,
  },
};
</script>
